/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Load_Users_FailedInputs */



/**
* | output |
* | --- |
* | "Error loading users. {error}" |
*
* @param {Team_Manager_Load_Users_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_load_users_failed = /** @type {((inputs: Team_Manager_Load_Users_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Load_Users_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors du chargement des utilisateurs. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Laden der Benutzer. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante il caricamento degli utenti. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка загрузки пользователей. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al cargar usuarios. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`加载用户时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ユーザーの読み込み中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपयोगकर्ताओं को लोड करने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao carregar usuários. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error loading users. ${i?.error}`)
});